<template>
  <div class="Home">
    <div class="block">
      <span class="demonstration"></span>
      <el-carousel :interval="4000" type="card" height="500px">
        <el-carousel-item
          v-for="(item, index) in imgwrap"
          style="background-size:100%:"
          :key="index"
        >
          <img :src="item.LinkUrl" alt="" />
        </el-carousel-item>
      </el-carousel>
      <!-- <el-carousel height="30rem">
       
        <el-carousel-item v-for="item in imgwrap"
                          :key="item.url"
                          @change="aa(item.text)">
          <div class="pic_item">
            <img class="small"
                 :src="item.url" />
          </div>
        </el-carousel-item>
      </el-carousel> -->
    </div>

    <div class="instructions">
      <p>The customer evaluation</p>
      <div>
        <div>
          <hr />
          <i>客户评价</i>
          <hr />
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            width: 100vw;
            overflow: scroll;
          "
        >
          <div
            style="
              width: 15%;
              border: 0.1rem solid #333;
              margin-right: 0.2rem;
              padding: 0.5rem;
              box-shadow: 00.1rem 0.1rem 0.1rem #333;
            "
            v-for="(item, index) in commentsList"
            :key="index"
          >
            <div style="display: flex; align-items: center">
              <img
                class="commentsListHeader"
                :src="item.UserDto.Avatar"
                alt=""
              />
              <div style="height: 2rem">
                <div style="color: #000; text-align: left; font-size: 1.2rem">
                  {{ item.UserDto.NickName }}
                </div>
                <div style="color: #000; font-size: 1rem">
                  {{ item.CreatedTime }}
                </div>
              </div>
            </div>
            <el-rate style="height: 1rem" v-model="item.Star"> </el-rate>
            <div>{{ item.Content }}</div>
            <div class="flexImg">
              <img
                v-for="(iten, index) in item.ImgDtos"
                :key="index"
                :src="iten.ImgUrl"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <p>OUR INDUSTRY</p>
      <div>
        <div>
          <hr />
          <i>我们的分布</i>
          <hr />
        </div>
        <i
          >公司先后与全球超过4,000家高科技研发、制造和服务企业进行合作，产品应用于通信、工控、轨道交通、医<br />
          疗电子、计算机及外设、半导体、汽车电子等领域，资源遍及全球三十多个国家和地区。</i
        >
        <div class="flex">
          <span
            @mouseover.stop="after($event, 1)"
            @mouseout.stop="leave($event, 1)"
          >
            <img :src="img.img1" alt="" />
            <p :class="{ animation: img.isActive1 }">
              <i>通信设备</i><br />
              <i>Communication Device</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 2)"
            @mouseout.stop="leave($event, 2)"
          >
            <img :src="img.img2" alt="" />
            <p :class="{ animation: img.isActive2 }">
              <i>计算机及外设</i><br />
              <i>Computer and Peripherals</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 3)"
            @mouseout.stop="leave($event, 3)"
          >
            <img :src="img.img3" alt="" />
            <p :class="{ animation: img.isActive3 }">
              <i>轨道交通</i> <br /><i>Rail Transit</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 4)"
            @mouseout.stop="leave($event, 4)"
          >
            <img :src="img.img4" alt="" />
            <p :class="{ animation: img.isActive4 }">
              <i>汽车电子</i><br /><i>Vehicle Electronics</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 5)"
            @mouseout.stop="leave($event, 5)"
          >
            <img :src="img.img5" alt="" />
            <p :class="{ animation: img.isActive5 }">
              <i>医疗电子</i><br /><i>Medical Electronics</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 6)"
            @mouseout.stop="leave($event, 6)"
          >
            <img :src="img.img6" alt="" />
            <p :class="{ animation: img.isActive6 }">
              <i>工业控制</i><br /><i>Industrial Control</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 7)"
            @mouseout.stop="leave($event, 7)"
          >
            <img :src="img.img7" alt="" />
            <p :class="{ animation: img.isActive7 }">
              <i>半导体集成电路</i><br />
              <i>Semiconductor Integrated Circuit</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 8)"
            @mouseout.stop="leave($event, 8)"
          >
            <img :src="img.img8" alt="" />
            <p :class="{ animation: img.isActive8 }">
              <i>教育</i><br /><i>Education</i>
            </p>
          </span>
          <span
            @mouseover.stop="after($event, 9)"
            @mouseout.stop="leave($event, 9)"
          >
            <img :src="img.img9" alt="" />
            <p :class="{ animation: img.isActive9 }">
              <i>贸易</i><br /><i>Trade</i>
            </p>
          </span>
        </div>
        <div>
          <p>OUR PARTNERS</p>
          <div>
            <hr />
            <i>合作伙伴</i>
            <hr />
          </div>
          <img src="../../assets/imges/21.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mutations } from "vuex";
import axios from "axios";
import { getHome } from "../../api/http/home";
import companyShowsVue from "../home/companyShows.vue";
export default {
  data() {
    return {
      hidden: {
        login: false,
        mation: true,
      },
      commentsList: "", //评论表格
      information: {
        uname: "",
        User_Phone: "",
      },

      company: require("../../assets/imges/20.jpg"),
      companyflase: require("../../assets/imges/0.png"),
      companyflase1: require("../../assets/imges/0.png"),
      input: "",
      //  轮播图
      imgwrap: [],
      //产品分布图片
      img: {
        img1: require("../../assets/imges/home_01.jpg"),
        isActive1: false,
        img2: require("../../assets/imges/home_02.jpg"),
        isActive2: false,
        img3: require("../../assets/imges/home_03.jpg"),
        isActive3: false,
        img4: require("../../assets/imges/home_04.jpg"),
        isActive4: false,
        img5: require("../../assets/imges/home_05.jpg"),
        isActive5: false,
        img6: require("../../assets/imges/home_06.jpg"),
        isActive6: false,
        img7: require("../../assets/imges/home_07.jpg"),
        isActive7: false,
        img8: require("../../assets/imges/home_08.jpg"),
        isActive8: false,
        img9: require("../../assets/imges/home_09.jpg"),
        isActive9: false,
      },
      img1: {
        img1: require("../../assets/imges/home_01.jpg"),
        img2: require("../../assets/imges/home_02.jpg"),
        img3: require("../../assets/imges/home_03.jpg"),
        img4: require("../../assets/imges/home_04.jpg"),
        img5: require("../../assets/imges/home_05.jpg"),
        img6: require("../../assets/imges/home_06.jpg"),
        img7: require("../../assets/imges/home_07.jpg"),
        img8: require("../../assets/imges/home_08.jpg"),
        img9: require("../../assets/imges/home_09.jpg"),
      },
      //  鼠标经过图片
      afterimg: {
        img1: require("../../assets/imges/11.jpg"),
        img2: require("../../assets/imges/12.jpg"),
        img3: require("../../assets/imges/13.jpg"),
        img4: require("../../assets/imges/14.jpg"),
        img5: require("../../assets/imges/15.jpg"),
        img6: require("../../assets/imges/16.jpg"),
        img7: require("../../assets/imges/17.jpg"),
        img8: require("../../assets/imges/18.jpg"),
        img9: require("../../assets/imges/19.jpg"),
      },
    };
  },
  created() {
    // 评价
    this.getCommen();
    // 轮播图片请求
    this.getHomeList();
    let token = window.sessionStorage.getItem("token");
    if (token == null) {
      this.hidden.mation = true;
      this.hidden.login = false;
    } else {
      this.hidden.mation = false;
      this.hidden.login = true;
      this.information.name = window.sessionStorage.getItem("Contact");
      this.information.User_Phone = window.sessionStorage.getItem("User_Phone");
    }
  },
  methods: {
    getCommen() {
      getHome.getComment({ page: 1, size: 15 }).then((res) => {
        this.commentsList = res.data.data;
      });
    },
    // 轮播图js请求
    getHomeList() {
      let this_ = this;
      axios
        .all([
          getHome.getBanner({
            type: 1,
          }),
          getHome.getBanner({
            type: 2,
          }),
        ])
        .then(
          axios.spread(function (acct, perms, res) {
            this_.imgwrap = acct.data.data;
            // console.log(perms);
            // console.log(res);
          })
        );
    },

    // 登录事件

    // 鼠标经过
    after(e, i) {
      //   e.currentTarget.className="col-lg-3 col-xs-6 paddingLeft com_marginBtm10 choosePlan active"
      switch (i) {
        case 1:
          this.img.img1 = this.afterimg.img1;
          this.img.isActive1 = true;
          break;
        case 2:
          this.img.img2 = this.afterimg.img2;
          this.img.isActive2 = true;
          break;
        case 3:
          this.img.img3 = this.afterimg.img3;
          this.img.isActive3 = true;
          break;
        case 4:
          this.img.img4 = this.afterimg.img4;
          this.img.isActive4 = true;
          break;
        case 5:
          this.img.img5 = this.afterimg.img5;
          this.img.isActive5 = true;
          break;
        case 6:
          this.img.img6 = this.afterimg.img6;
          this.img.isActive6 = true;
          break;
        case 7:
          this.img.img7 = this.afterimg.img7;
          this.img.isActive7 = true;
          break;
        case 8:
          this.img.img8 = this.afterimg.img8;
          this.img.isActive8 = true;
          break;
        case 9:
          this.img.img9 = this.afterimg.img9;
          this.img.isActive9 = true;
          break;
      }
    },
    // 鼠标离开
    leave(e, i) {
      switch (i) {
        case 1:
          this.img.img1 = this.img1.img1;
          this.img.isActive1 = false;
          break;
        case 2:
          this.img.img2 = this.img1.img2;
          this.img.isActive2 = false;
          break;
        case 3:
          this.img.img3 = this.img1.img3;
          this.img.isActive3 = false;
          break;
        case 4:
          this.img.img4 = this.img1.img4;
          this.img.isActive4 = false;
        case 5:
          this.img.img5 = this.img1.img5;
          this.img.isActive5 = false;
          break;
        case 6:
          this.img.img6 = this.img1.img6;
          this.img.isActive6 = false;

          break;
        case 7:
          this.img.img7 = this.img1.img7;
          this.img.isActive7 = false;
          break;
        case 8:
          this.img.img8 = this.img1.img8;
          this.img.isActive8 = false;
          break;
        case 9:
          this.img.img9 = this.img1.img9;
          this.img.isActive9 = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.flexImg {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  img {
    width: 50%;
  }
}
.commentsListHeader {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
}
.el-carousel__item:nth-child(2n) {
  background-image: url(../../assets/imges/1015.png);
  background-repeat: no-repeat;
  background-size: 100%;
  div {
    color: #fff;
  }
}
.el-carousel__item:nth-child(2n + 1) {
  background-image: url(../../assets/imges/1025.jpg);
  background-repeat: no-repeat;
  background-size: 100%;
  div {
    color: #f00;
  }
}

.el-carousel__item:nth-child(3) {
  background-image: url(../../assets/imges/14.jpg);
  background-repeat: no-repeat;
  background-size: 100%;
}
.el-carousel__item:nth-child(4) {
  background-image: url(../../assets/imges/06.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
// .el-carousel__item:nth-child(2) {
//  background-image: url(../../assets/imges/06.png);
//   background-repeat: no-repeat;
//     background-size: 100%;
// }
// .el-carousel__item:nth-child(2) {
//  background-image: url(../../assets/imges/06.png);
//   background-repeat: no-repeat;
//     background-size: 100%;
// }
// .el-carousel__item:nth-child(3) {
//  background-image: url(../../assets/imges/07.png);
//   background-repeat: no-repeat;
//     background-size: 100%;
// }
// .el-carousel__item:nth-child(4) {
//  background-image: url(../../assets/imges/05.png);
//   background-repeat: no-repeat;
//     background-size: 100%;
// }

.CompanyProfile {
  margin-top: 4rem;

  .img {
    p {
      margin: auto;

      i {
        color: #fff;
      }
    }
  }
  p {
    font-size: 1.5rem;
    div {
      i {
        font-size: 1rem;
      }
      hr {
        display: inline-block;
        width: 3rem;
      }
    }
  }
}
@keyframes mymove {
  0% {
    top: 0rem;
  }
  50% {
    top: 15rem;
  }
  100% {
    top: 15rem;
    right: 5rem;
  }
}
.animation {
  animation-name: mymove;
  animation-duration: 1s;
}
// 产品说明
.instructions {
  width: 100%;
  text-align: center;
  .flex {
    width: 80%;
    margin: auto;
    margin-bottom: 1rem;
    span {
      position: relative;
      flex: 33.33%;
      img {
        width: 90%;
      }
      p {
        text-align: right;
        position: absolute;
        z-index: 2;
        bottom: 0;
        right: 1rem;
      }
    }
    img {
      margin-left: 1rem;
      margin-top: 1rem;
    }
  }
  p {
    font-size: 1.5rem;
    margin: 2rem 0 2rem 0;
    color: #2bae85;
  }
  div {
    i {
      font-size: 1.2rem;
    }
    margin-bottom: 1rem;
  }
  i {
    font-style: unset;
  }
  hr {
    display: inline-block;
    width: 5rem;
    margin-bottom: 0.3rem;
  }
}
// 轮播
.block {
  img {
    width: 100%;
    height: 40rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/Home.vue